import { useLanguage } from '@orientaction/hooks';
import { getFromLS } from '@orientaction/utils';
import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useMajorTestPassStyles } from './index.styles';

const APP_KEY = 'e9f7a4c2-2e1e-4f8d-bf68-a2d64a096819';
const WIDGET_SRC = 'https://cbassets.botnation.ai/js/widget.js';
const SCRIPT_ID = 'chatbox-jssdk';

type MajorTestBot = {
  websiteId: string | ((language: string) => string);
  autoStart: boolean;
  requiresAuth: boolean;
};

const frenchOrEnglish = (frenchId: string, englishId: string) => (language: string) =>
  language === 'GB' ? englishId : frenchId;

const BOTS: { pattern: RegExp; bot: MajorTestBot }[] = [
  {
    pattern: /\/tests\/harmony$/,
    bot: {
      websiteId: frenchOrEnglish('con41t5rElN0HstL', '8CE17K9winglCbabbi'),
      autoStart: true,
      requiresAuth: true,
    },
  },
  {
    pattern: /\/tests\/(?:sens-valeurs|meaning-values)$/,
    bot: {
      websiteId: frenchOrEnglish('supe6Za4kers2GeX2G', 'RoRoOat0is9s95eQ'),
      autoStart: true,
      requiresAuth: true,
    },
  },
  {
    pattern: /\/tests\/(?:besoins-pro|needs-pro)$/,
    bot: {
      websiteId: frenchOrEnglish('st8DDatRci5v4Nn9', 'bKai95ViaKB60pth'),
      autoStart: true,
      requiresAuth: true,
    },
  },
  {
    pattern: /\/tests\/(?:besoins|needs)$/,
    bot: {
      websiteId: 'de4TctsOr0pu9MSlingu2',
      autoStart: false,
      requiresAuth: true,
    },
  },
  {
    pattern: /\/tests\/(?:preferences-personnalites|preferences-personality)$/,
    bot: {
      websiteId: frenchOrEnglish('62tC5VsurQa0Cdhull', '07tard1prD9iROcK'),
      autoStart: false,
      requiresAuth: true,
    },
  },
  {
    pattern: /\/tests\/preferences-jeune$/,
    bot: {
      websiteId: 'decIpA6l78ion8YTni',
      autoStart: false,
      requiresAuth: true,
    },
  },
  {
    pattern: /\/tests\/study$/,
    bot: {
      websiteId: '5hrMadi22tinK4rpeSH',
      autoStart: false,
      requiresAuth: false,
    },
  },
];

const botForPath = (pathname: string) => BOTS.find(entry => entry.pattern.test(pathname))?.bot;

const loadBot = (websiteId: string, autoStart: boolean) => {
  (window as any).chatboxSettings = {
    appKey: APP_KEY,
    websiteId,
    preventMessengerPreload: true,
    language: 'fr',
    ref: 'restart',
    ...(autoStart ? { autoStart: true } : {}),
  };

  if (document.getElementById(SCRIPT_ID)) {
    return;
  }

  const script = document.createElement('script');
  script.id = SCRIPT_ID;
  script.src = WIDGET_SRC;
  script.async = true;
  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode?.insertBefore(script, firstScript);
};

const MajorTestPass = () => {
  const classes = useMajorTestPassStyles();
  const history = useHistory();
  const { pathname } = useLocation();
  const { language } = useLanguage();
  const bot = botForPath(pathname);
  const token = getFromLS('userToken') || '';
  const userConnected = JSON.parse(getFromLS('userInfos') || '{}');
  const canViewTest = token.length > 0 && Boolean(userConnected?.id);

  useEffect(() => {
    if (!bot) {
      return;
    }

    if (bot.requiresAuth && !canViewTest) {
      history.push('/');
      return;
    }

    const websiteId = typeof bot.websiteId === 'function' ? bot.websiteId(language) : bot.websiteId;
    loadBot(websiteId, bot.autoStart);
  }, [bot, canViewTest, history, language]);

  return <div className={classes.page} />;
};

export default MajorTestPass;
